import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Box,
} from "@mui/material";

const STATUS_OPTIONS = ["OPEN", "SUBMITTED", "COMPLETED"];

export default function AddTaskDialog({ open, onClose, onSave }) {
  const [form, setForm] = useState({
    title: "",
    assignedTo: "",
    createdBy: "",
    status: "OPEN",
  });

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    if (!form.title.trim()) return;
    
    onSave({
      ...form,
      id: Date.now(), // Simple unique ID
    });
    
    // Reset form
    setForm({
      title: "",
      assignedTo: "",
      createdBy: "",
      status: "OPEN",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add New Task</DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="Task Title"
            fullWidth
            required
            value={form.title}
            onChange={handleChange("title")}
          />

          <TextField
            label="Assigned To"
            fullWidth
            value={form.assignedTo}
            onChange={handleChange("assignedTo")}
          />

          <TextField
            label="Created By"
            fullWidth
            value={form.createdBy}
            onChange={handleChange("createdBy")}
          />

          <TextField
            label="Status"
            select
            fullWidth
            value={form.status}
            onChange={handleChange("status")}
          >
            {STATUS_OPTIONS.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!form.title.trim()}
        >
          Add Task
        </Button>
      </DialogActions>
    </Dialog>
  );
}
